import * as React from "react";
import { SVGProps } from "react";

const UquidCoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 584 561"
    {...props}
  >
    <style>
      {
        ".st0{fill:#e85c50}.st1{fill:#cf3339}.st3{fill:#e34c37}.st8{fill:#e04437}"
      }
    </style>
    <path
      d="M193.6.6c.5.2.8.6.7 1.1v356c0 1.2-.1 2.3-.1 3.5.5 1 1.4.5 2 .5 63.4 0 126.8 0 190.3.1 2 0 2.9-.5 2.6-2.6V4.5c0-1.2-.7-2.8.8-3.7.5-.4 1.3-.3 1.7.2 0 0 0 .1.1.1.5.7 1 1.4 1.4 2.2 7.2 14.3 14.6 28.7 21.7 43 5.9 12 11.9 24 17.8 35.9 6.6 13.2 13.3 26.5 19.9 39.7 6 11.9 11.9 23.9 17.8 35.8 5.3 10.8 10.8 21.4 16 32.2.8 1.6 2 2.9 2.5 4.6.3 2 .3 4.1.2 6.1v346.9c0 3.8 0 3.8 3.7 4.5.5.1.9.3 1.3.7-2.5 1.2-5.1 1.6-7.8 2.2-11.8 2.8-23.7 4.6-35.8 5.5-5.6.4-11.2.5-16.8.6-28.9.5-57.9.3-86.8.3-50.2 0-100.5 0-150.8-.1-1 0-2.1.3-3.1-.3.3-.2.6-.5 1-.6 1.8-.4 3.6-.5 5.5-.4h183.9c1.6.1 3.3 0 4.9-.2 1.5-.7.9-2 1-3.1V370.2c-.1-1.3 0-2.6.1-3.9-1.5 4.7-4 9.1-6.2 13.6-8.1 16.9-16 33.9-24.1 50.9-4.4 9.3-8.8 18.5-13.2 27.8-.6 1.3-1.2 2.7-2.6 3.4-1.4.4-2.9.5-4.3.4h-94.6c-1.3.1-2.5 0-3.8-.3-1.9-.6-2.5-2.3-3.2-3.9-5.5-11.7-11.1-23.4-16.6-35.2-6-12.7-12-25.3-18-38-2.9-6-5.6-12.1-8.8-18.4v188.6c0 1.9.5 3.9-.9 5.6-1 0-1.9.2-2.9.2h-42.9c-3.7 0-7.3-.2-11-.3-.7 0-1.4.1-1.9-.4.7-.6 1.5-.3 2.2-.3H189c.7 0 1.3-.1 1.5 0h-53.1c-1 0-2.1-.4-3.1.4-4.4.2-8.9-.4-13.3-.9-8.6-.8-17-2.6-25.4-4-.3-.1-.5-.2-.8-.4 1-2.2.9-4.5.9-6.8V202.1c-.1-2 0-4.1.2-6.1.5-2.1 1.3-4.1 2.3-5.9 6-11.9 12-23.8 17.9-35.8 21.8-44.7 44.3-89 66.4-133.5 2.8-5.6 5.6-11 8.3-16.6.4-.9.7-2.8 2.5-1.2v357.1V5.9c-.1-1.9-.7-3.6.3-5.3z"
      className="st0"
    />
    <path
      d="M96.5 194.7v358.6c.1 1.4-.8 1.6-1.8 1.7-14.3-3.3-28.2-7.7-41.2-14.4-7.2-3.7-14.2-7.6-20.4-12.7-17.2-14.1-29.2-31.4-31.8-54.1v-2.3c-.3-1-.4-2.1-.2-3.2V6.7c-.1-1.1 0-2.1.2-3.2 1.4.1 1.7 1.3 2.1 2.2 5.3 10.8 10.6 21.5 16 32.2 6.5 12.9 13 25.7 19.4 38.7 6 12 12.1 24 18 36.1 3.7 7.6 7.6 15.1 11.3 22.6 3.5 6.9 7 13.8 10.4 20.8 4 8.4 8.2 16.7 12.5 24.9 1.9 3.5 3.3 7.2 5.1 10.8.6.8.7 1.9.4 2.9zm397.5 358c-1.4-.1-2.7.1-4 .5-1.1.2-1.9-.1-1.9-1.5V193.6c-.9-1.6.3-2.8.9-4 9.6-18.7 19.1-37.5 28.5-56.4.2-.4.5-.9.8-1.3l.3-.6c.2-.3.3-.6.5-.9s.2-.4.3-.6c.3-.6.6-1.3.9-1.9.1-.2.3-.5.4-.7 5-9.4 9.6-19 14.4-28.6 2.6-5 5-10 7.5-15.1 2.3-4.5 4.5-8.9 6.7-13.4.2-.3.3-.6.5-.8 7.4-14.4 14.4-29 21.8-43.3 3.1-5.9 6.1-11.9 9.2-17.8.5-1.1.9-2.4 2.5-2.7.6 1.2.3 2.4.3 3.6v456.2c.1 1.2.1 2.3-.2 3.5.4 4.2-1.2 8-2.2 11.9-3.2 12.4-10 22.7-18.4 32.1-6.3 7.3-13.6 13.8-21.7 19.1-10.2 6.7-21.2 12.2-32.7 16.4-4.6 1.6-9.5 3.2-14.4 4.4z"
      className="st1"
    />
    <path
      fill="#e33936"
      d="M96.5 194.7c-.2-1-.5-1.9-1.1-2.7-2.7-5.7-5.7-11.2-8.3-16.9-2.6-5.5-5.8-10.7-8.2-16.3-2.2-5.2-5.3-9.9-7.5-15-2.8-6.5-6.7-12.4-9.3-19-1-2.6-2.7-4.9-3.9-7.4-1.9-3.8-3.4-7.8-5.5-11.5-4.1-7.2-7.4-14.9-11.2-22.2-2.5-4.8-5.1-9.5-7.3-14.5-2.4-5.4-5.6-10.4-7.9-15.8-2.8-6.6-6.7-12.6-9.5-19.2-1.3-3.2-3.4-6.1-4.8-9.3-3.2-7-7.3-13.6-10.8-20.7v467.3c-1-3.2-.7-6.5-.7-9.8-.1-41-.1-82.1 0-123.1V9.3C.6 6.4.5 3.5.2.6 1.1.3 2.1.2 3 .4h188.7c2.1 0 1.3 1.1.7 2l-37.9 75.5c-7.9 15.8-15.8 31.5-23.6 47.3-2.9 5.8-5.6 11.7-8.5 17.5l-24 48-1.9 4zm421.8-62.1c-.1.8-.4 1.5-.8 2.1-6.3 12.7-12.6 25.5-19.1 38.1-3.1 6-6.1 12-9.2 18.1-.5.8-.9 1.7-1.1 2.7-1.1 0-1.4-1-1.7-1.7-1.3-2.5-2.3-5.1-3.6-7.6-1.5-3-3.2-6-4.7-9-2.8-5.5-5.7-11-8.3-16.6-2.7-5.9-6.1-11.4-8.7-17.4-2.8-6.4-6.5-12.3-9.2-18.7-1.5-3.5-3.6-6.8-5.3-10.3-2.7-5.4-5.6-10.8-8.1-16.3-2.9-6.3-6.5-12.3-9.2-18.7-1.5-3.5-3.7-6.8-5.3-10.3-3-6.7-6.8-13-9.7-19.8-1.5-3.5-3.6-6.8-5.3-10.3-5.5-11.1-11.1-22.1-16.6-33.2-.6-.9-1-1.9-1.2-2.9l.5-.3c37.9-.1 75.8 0 113.8 0H581c1 0 2.1-.3 3.1.3.1.8 1 1.5.1 2.4-2.8 3.3-4.1 7.4-6 11.1-9.6 18.6-18.9 37.4-28.3 56.2-2.4 4.4-4.7 8.9-6.8 13.4-2.6 5-5.1 10-7.6 15.1-5 9.6-9.6 19.5-14.7 29-.5.7-.9 1.5-1.2 2.3-.4.3-.3.9-.6 1.2-.5.2-.4.8-.7 1.1z"
    />
    <path
      d="M549.7 70.4c1.5-5.2 4.3-9.9 6.9-14.6.9-1.6 1.5-3.3 2.3-5 3.5-6.8 6.8-13.6 10.2-20.4 2.7-5.3 5.2-10.7 8-16 1.9-3.5 3.5-7 5.3-10.6.4-.8.7-1.4 1.7-.8v457.7c0 2.6.2 5.2-.5 7.8 0-1-.1-1.9-.1-2.9V5.9c-.9.1-1 .8-1.2 1.4-1 1.9-1.9 3.8-2.9 5.7-9.5 18.3-18.7 36.7-27.9 55.2-.5.8-.8 1.8-1.8 2.2z"
      className="st3"
    />
    <path
      fill="#e9654c"
      d="M391.1.7c-1.2.2-2 1.3-1.8 2.5v354.7c0 4.6.5 4.2-4.2 4.2H197.8c-1.2 0-2.7.7-3.7-.8 1 .4 2.1.5 3.1.4H387c1.4.1 2-.4 1.9-1.8-.1-.9 0-1.7 0-2.6V2.5c-.2-1.7.7-2.3 2.2-2.2v.4z"
    />
    <path
      fill="#e7563d"
      d="M192.3 2.5c0-.8.7-1.9-1-1.7H0C.8-.3 2 .3 2.9.3 16.2.2 29.4.3 42.6.3h147.1c1.2 0 2.5-.4 3.7.5v360.1c-.9-.4-.5-1.1-.6-1.6V6.4c.1-1.4.6-2.8-.5-3.9z"
    />
    <path
      d="M391.1.7V.3c1.1-.1 2.1-.2 3.2-.2h186.5c1.1 0 2.3-.5 3.2.5L391.1.7z"
      className="st0"
    />
    <path
      d="M389.3 560.7H197c-1.2 0-2.3-.1-3.5-.1-.2-1.2 0-2.3.6-3.4 5-10.5 9.9-21 14.9-31.5 9.9-20.7 19.6-41.5 29.5-62.1.3-.8.8-1.6 1.4-2.1h103.4c2.5 4.4 4.5 9 6.6 13.5 4 8.7 8.2 17.3 12.3 26 8.8 18.5 17.6 37.1 26.3 55.6.8 1.3 1.1 2.7.8 4.1z"
      className="st1"
    />
    <path
      fill="#e33937"
      d="M240 461.5c-.4 1.7-1 3.3-1.9 4.9-4.8 10-9.7 20-14.4 30l-9.6 20.4c-3.7 7.9-7.4 15.7-11.2 23.5-2.8 5.8-5.5 11.7-8.2 17.6-.4.9-.7 1.8-1.1 2.7l-.7.2V364c.9.6 1.6 1.5 1.9 2.5 1.9 4.2 3.8 8.5 5.8 12.6 3.1 6.5 6.3 12.9 9.3 19.3 5.3 11.4 10.7 22.7 16.1 34 3.2 6.7 6.3 13.5 9.6 20.2 1.4 3 2.4 6.2 4.4 8.9zm149.3 99.2c-.7-3.5-2.7-6.4-4-9.6-1.7-4.1-3.7-8-5.7-12.1-4.5-9.4-9.1-18.8-13.5-28.2L355.3 488c-3.9-8-7.5-16.1-11.3-24.1-.4-.8-.7-1.6-.7-2.5 5.8-12.2 11.7-24.4 17.4-36.7 3.4-7.2 6.8-14.3 10.2-21.5 3.8-8 7.5-15.9 11.3-23.8 2-4.2 3.9-8.4 5.8-12.6.3-1 .9-2 1.8-2.7v193.3c.1 1.2.5 2.4-.5 3.3z"
    />
    <path
      fill="#e75840"
      d="M134.1 560.3c.6-.8 1.6-.7 2.4-.7h54.3c.4 0 .8.1 1.2.2-1.1.4-2.2.5-3.3.3h-52c-.8.1-1.7.2-2.6.2z"
    />
    <path
      d="M520.6 127.9c.1-.7.3-1.3.7-1.9l12.9-25.8c.2-.6.5-1 1-1.4.2-.3.4-.3.6 0-4.4 8.9-8.9 17.7-13.3 26.6-.5.9-.8 2.1-1.9 2.5z"
      className="st8"
    />
    <path
      fill="#e24837"
      d="M535.7 98.9h-.6c1.2-3.6 3.3-6.9 4.9-10.4.8-1.6 1.3-3.4 2.6-4.7.2-.3.4-.3.6 0l-7.5 15.1z"
    />
    <path
      d="M543.3 83.8h-.6c1.9-4.7 3.9-9.3 7-13.4.1.6-.1 1.2-.3 1.7-2.4 3.7-4.1 7.8-6.1 11.7z"
      className="st3"
    />
    <path
      d="M519.5 130.2c-.2-1 .3-1.9 1.2-2.3-.1.9-.5 1.8-1.2 2.3zm-.6 1.3c-.1-.5.2-.9.6-1.2 0 .5-.2.9-.6 1.2z"
      className="st8"
    />
    <path
      d="M518.3 132.6c-.1-.5.2-.9.6-1.2 0 .5-.2.9-.6 1.2z"
      className="st8"
    />
  </svg>
);

export default UquidCoin;
